import { render, staticRenderFns } from "./main-tabs.vue?vue&type=template&id=010b6aab&"
import script from "./main-tabs.vue?vue&type=script&lang=js&"
export * from "./main-tabs.vue?vue&type=script&lang=js&"
import style0 from "./main-tabs.vue?vue&type=style&index=0&id=010b6aab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports